import isNewConsumerApp from 'commons/isNewConsumerApp';
import isUnitTestEnv from 'commons/isUnitTestEnv';
import useAllOptionsNew from './useAllOptionsNew';
import useAllOptionsOld from './useAllOptionsOld';

const useAllOptions =
  isNewConsumerApp || isUnitTestEnv() ? useAllOptionsNew : useAllOptionsOld;

export default useAllOptions;
